<template>
  <section class="dark clean-modal">
    <div class="modal-container active">
      <div class="modal-window fullscreen" id="object">
        <TheLoader :active="loading"/>

        <component v-if="!loading" v-bind:is="selectedContentComponent" v-bind="{kunde: kunde, kontrakt: kontrakt, objekt: objekt}"></component>
      </div>
    </div>
  </section>
</template>

<script>
import KundeService from '@/services/KundeService'
import KundeKontraktObjekt from './KundeKontraktObjekt'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktObjektFullscreen',
  data () {
    return {
      kunde: {
        type: Object,
        required: true
      },
      kontrakt: {
        type: Object,
        required: true
      },
      objekt: {
        type: Object,
        required: true
      },
      loading: true,
      selectedContentComponent: KundeKontraktObjekt
    }
  },
  mounted () {
    bus.$on('hide-kunde-kontrakt-objekt', () => this.onHideKundeKontraktObjekt())
  },
  created () {
    bus.$off('hide-kunde-kontrakt-objekt')
    this.fetch()
  },
  methods: {
    fetch: function () {
      this.loading = true

      let regex = /^\d+$/
      let kundeNr = this.$route.params.kunde_id
      let kontraktNr = this.$route.params.kontrakt_id
      let objektNr = this.$route.params.objekt_id

      if (!regex.test(kontraktNr) || !regex.test(objektNr)) {
        this.$helpers.showErrorAlert('Feil', 'Objekt ikke funnet')
        this.goHome()
      } else {
        KundeService.loadKundeWithKontraktAndObjekt(kundeNr, kontraktNr, objektNr)
          .then((response) => {
            this.kunde = response.kunde
            this.kontrakt = response.kontrakt
            this.objekt = response.objekt
          })
          .catch(() => {
            this.$helpers.showErrorAlert('Feil', 'Objekt ikke funnet')
            this.goHome()
          })
          .then(() => {
            this.loading = false
          })
      }
    },
    onHideKundeKontraktObjekt: function () {
      if (this.$route.query.searchResult) {
        this.$router.push({ query: { ...this.$route.query, search: true } })
      } else {
        this.$router.push({
          name: 'KundeCard',
          params: {kunde_id: this.kunde.Kundenr},
          query: {kontrakt: this.kontrakt.Kontraktnr},
          hash: ''
        })
      }
    },
    goHome: function () {
      this.$router.push({name: 'Dashboard'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektFullscreen.vue